import { render, staticRenderFns } from "./UpfrontContributionBase.vue?vue&type=template&id=1a724f70"
import script from "./UpfrontContributionBase.vue?vue&type=script&lang=ts"
export * from "./UpfrontContributionBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports